import { useEffect, useState } from "react";
import { Moon, Sun, Palette } from "lucide-react";
import { Button } from "@/components/ui/button";

const THEMES = ["dark", "light", "purple"];
const ICONS = { dark: Moon, light: Sun, purple: Palette };
const LABELS = { dark: "Oscuro", light: "Claro", purple: "Purple UC" };

export function ThemeToggle() {
  const [theme, setTheme] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("via-theme") || "dark";
    }
    return "dark";
  });

  useEffect(() => {
    const root = document.documentElement;
    // Remove all theme classes
    root.classList.remove("dark", "light", "purple");
    // Add current
    root.classList.add(theme);
    localStorage.setItem("via-theme", theme);
  }, [theme]);

  const cycle = () => {
    const idx = THEMES.indexOf(theme);
    setTheme(THEMES[(idx + 1) % THEMES.length]);
  };

  const Icon = ICONS[theme] || Moon;

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={cycle}
      className="h-8 w-8"
      title={`Tema: ${LABELS[theme]} — click para cambiar`}
    >
      <Icon className="h-4 w-4 text-muted-foreground hover:text-foreground transition-colors" />
    </Button>
  );
}
